import { Controller } from "@hotwired/stimulus"

// Mostrar/ocultar un bloque (acordeones del menú móvil, secciones opcionales
// de formularios). Reemplaza los collapsible de Materialize.
export default class extends Controller {
  static targets = ["content", "icon"]

  toggle(event) {
    event?.preventDefault()
    const willOpen = this.contentTarget.classList.contains("hidden")

    this.contentTarget.classList.toggle("hidden", !willOpen)
    this.iconTarget?.classList.toggle("rotate-180", willOpen)
    // El botón que dispara la acción anuncia el estado a lectores de pantalla.
    event?.currentTarget?.setAttribute("aria-expanded", String(willOpen))
  }
}
